import React from "react";
import Banner from "../components/comman/Banner";
import AboutBanner from "../components/about/AboutBanner";
import VisionMission from "../components/about/VisionMission";
// import Teams from "../components/about/Teams";
const About = () => {
    return (
        <div>
            <Banner title="About" />
            <AboutBanner />
            <VisionMission />
            {/* <Teams /> */}
        </div>
    );
}

export default About;